import { InjectionToken } from '@angular/core';

export type SwitchClientFunc = (clientId: string) => void;
export const BEFORE_SWITCH_CLIENT_FUNC = new InjectionToken<SwitchClientFunc>('BEFORE_SWITCH_CLIENT_FUNC');
export const SWITCH_CLIENT_FUNC = new InjectionToken<SwitchClientFunc>('SWITCH_CLIENT_FUNC');
